import { CardDetailsMock, CardMock, TableMock } from './mock.interface';
import { ColumnDefs, ILead, IResponse } from '@pc/common';
export const mock: IResponse<ILead> = {
  count: 1722,
  type: 'leads',
  items: [
    {
      id: 8583462,
      creationDate: new Date('2023-10-01T16:16:41.84'),
      distributorUserId: 'guriy@tmu.co.il',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'משה',
      lastName: 'לוי',
      phoneType: '052',
      phoneTypeDesc: 'סלקום',
      prefix: '052',
      number: '2243523',
      email: 'bcbcvv123@gmail.com',
      notes: 'להתקשר לחידוש',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583230,
      creationDate: new Date('2023-09-26T09:13:45.72'),
      distributorUserId: 'מוקד מכירות',
      referrer: 'לקוח קיים',
      firstName: 'ללא כבודה',
      lastName: 'הריון',
      phoneType: 'MobileOrigin',
      phoneTypeDesc: 'נייד ישראל',
      prefix: '050',
      number: '3351316',
      email: 'pregnant@nolug5ge.ccc',
      notes: '',
      status: 'PolicyHasBeenIssued',
      statusDesc: 'הופקה פוליסה',
      participantsCount: 1,
      isOpen: false,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583227,
      creationDate: new Date('2023-09-26T08:50:52.96'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'קראק',
      lastName: 'קרארק',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '052',
      number: '3303317',
      email: 'sdf@wq.cv',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583226,
      creationDate: new Date('2023-09-26T08:48:57.22'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'FailedDouble',
      statusDesc: 'נכשל כפול',
      participantsCount: 1,
      isOpen: false,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583162,
      creationDate: new Date('2023-09-20T16:14:24.69'),
      distributorUserId: 'מוקד מכירות',
      referrer: 'לקוח קיים',
      firstName: 'לביא',
      lastName: 'אוטומיצה שניידר',
      phoneType: 'MobileOrigin',
      phoneTypeDesc: 'נייד ישראל',
      prefix: '051',
      number: '1369710',
      email: '1g7PP@gmail.com',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 5,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583161,
      creationDate: new Date('2023-09-20T16:14:24.277'),
      distributorUserId: 'מוקד מכירות',
      referrer: 'לקוח קיים',
      firstName: 'לביא',
      lastName: 'אוטומיצה שניידר',
      phoneType: 'MobileOrigin',
      phoneTypeDesc: 'נייד ישראל',
      prefix: '051',
      number: '1369710',
      email: '1g7PP@gmail.com',
      notes: '',
      status: 'WaitingForContact',
      statusDesc: 'ממתין להתקשרות',
      participantsCount: 5,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583032,
      creationDate: new Date('2023-09-14T15:33:41.55'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583031,
      creationDate: new Date('2023-09-14T15:33:21.233'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8583030,
      creationDate: new Date('2023-09-14T15:29:47.097'),
      distributorUserId: '',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'מנמנ',
      lastName: 'מנמנמ',
      phoneType: 'MobileOrigin',
      phoneTypeDesc: 'נייד ישראל',
      prefix: '052',
      number: '1221122',
      email: 'bvbv@gmail.com',
      notes: '',
      status: 'WaitingForContact',
      statusDesc: 'ממתין להתקשרות',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8582007,
      creationDate: new Date('2023-09-13T11:13:12.06'),
      distributorUserId: 'מוקד מכירות',
      referrer: 'לקוח קיים',
      firstName: 'רואי',
      lastName: 'אוטומיצה זקס',
      phoneType: 'MobileOrigin',
      phoneTypeDesc: 'נייד ישראל',
      prefix: '053',
      number: '9429874',
      email: 'CgLRE@gmail.com',
      notes: '',
      status: 'WaitingForContact',
      statusDesc: 'ממתין להתקשרות',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8582001,
      creationDate: new Date('2023-09-12T16:06:15.317'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8582000,
      creationDate: new Date('2023-09-12T16:05:25.633'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581999,
      creationDate: new Date('2023-09-12T16:05:13.673'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581994,
      creationDate: new Date('2023-09-12T15:31:23.073'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581993,
      creationDate: new Date('2023-09-12T15:28:16.583'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581992,
      creationDate: new Date('2023-09-12T15:02:03.013'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581991,
      creationDate: new Date('2023-09-12T15:00:43.207'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581988,
      creationDate: new Date('2023-09-12T13:07:02.897'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'צמצממצ',
      lastName: 'צמצמצמ',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '052',
      number: '1227788',
      email: 'nbnb987tt@gmail.com',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581987,
      creationDate: new Date('2023-09-12T13:06:08.753'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'FailedDouble',
      statusDesc: 'נכשל כפול',
      participantsCount: 1,
      isOpen: false,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581986,
      creationDate: new Date('2023-09-12T12:11:08.983'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581983,
      creationDate: new Date('2023-09-12T11:04:43.13'),
      distributorUserId: 'מוקד מכירות',
      referrer: 'לקוח קיים',
      firstName: 'אלן',
      lastName: 'אוטומיצה פריד',
      phoneType: 'MobileOrigin',
      phoneTypeDesc: 'נייד ישראל',
      prefix: '054',
      number: '8697031',
      email: 'Yjc0a@gmail.com',
      notes: '',
      status: 'WaitingForContact',
      statusDesc: 'ממתין להתקשרות',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581981,
      creationDate: new Date('2023-09-12T10:23:43.42'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'אתר 1',
      lastName: 'הצעה 1',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '',
      number: '',
      email: '',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581980,
      creationDate: new Date('2023-09-12T10:09:22.593'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'נהנה',
      lastName: 'כגכגכ',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '052',
      number: '1221122',
      email: 'mnm98@gmail.com',
      notes: '',
      status: 'UnderWritingWaitingForDocuments',
      statusDesc: 'בחיתום/ממתין למסמכים',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581979,
      creationDate: new Date('2023-09-12T10:09:10.39'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'נהנה',
      lastName: 'כגכגכ',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '052',
      number: '1221122',
      email: 'mnm98@gmail.com',
      notes: '',
      status: 'FailedDouble',
      statusDesc: 'נכשל כפול',
      participantsCount: 1,
      isOpen: false,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    },
    {
      id: 8581978,
      creationDate: new Date('2023-09-12T10:08:59.39'),
      distributorUserId: 'assaf@agent.com',
      referrer: 'ממשק מכירות סוכן',
      firstName: 'נהנה',
      lastName: 'כגכגכ',
      phoneType: 'Unknow',
      phoneTypeDesc: '',
      prefix: '052',
      number: '1221122',
      email: 'mnm98@gmail.com',
      notes: '',
      status: 'PriceOfferCreated',
      statusDesc: 'ניתנה הצעה',
      participantsCount: 1,
      isOpen: true,
      saleAgentNumber: '56219',
      agentSaleNumberName: 'ראשי'
    }
  ],
  lastUpdateTime: new Date('2023-10-02T09:58:53.5914013+03:00'),
  fromCache: false,
  isFilteredState: false
};

export const columnsDefLeads: ColumnDefs<ILead>[] = [
  {
    name: 'id',
    trans: 'תז',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'creationDate',
    trans: 'תאריך',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'distributorUserId',
    trans: 'מספר ספק',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'referrer',
    trans: 'גורם מפנה',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'firstName',
    trans: 'שם פרטי',
    width: -1,
    visible: true,
    group: 'lead',
    icon: 'calendar.svg'
  },
  {
    name: 'lastName',
    trans: 'שם משפחה',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'phoneType',
    trans: 'סוג טלפון',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'phoneTypeDesc',
    trans: 'סוג טל',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'prefix',
    trans: 'קידומת',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'number',
    trans: 'מספר',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'email',
    trans: 'אימייל',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'notes',
    trans: 'הערות',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'status',
    trans: 'סטטוס',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'statusDesc',
    trans: 'תיאור סטטוס',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'participantsCount',
    trans: 'כמות מבוטחים',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'isOpen',
    trans: 'פתוח',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'saleAgentNumber',
    trans: 'מספר סוכנות',
    width: -1,
    visible: true,
    group: 'lead'
  },
  {
    name: 'agentSaleNumberName',
    trans: 'שם סוכנות',
    width: -1,
    visible: true,
    group: 'lead'
  }
];

export const cardDetailsMock: CardDetailsMock<ILead> = {
  columns: columnsDefLeads,
  rowData: {
    id: 8583462,
    creationDate: new Date('2023-10-01T16:16:41.84'),
    distributorUserId: 'guriy@tmu.co.il',
    referrer: 'ממשק מכירות סוכן',
    firstName: 'משה',
    lastName: 'לוי',
    phoneType: '052',
    phoneTypeDesc: 'סלקום',
    prefix: '052',
    number: '2243523',
    email: 'bcbcvv123@gmail.com',
    notes: 'להתקשר לחידוש',
    status: 'PriceOfferCreated',
    statusDesc: 'ניתנה הצעה',
    participantsCount: 1,
    isOpen: true,
    saleAgentNumber: '56219',
    agentSaleNumberName: 'ראשי'
  },
  header: 'ליד מספר 12345678'
};

export const cardMock: CardMock<ILead> = {
  columns: columnsDefLeads.slice(4),
  rowData: cardDetailsMock.rowData,
  footerBorder: true
};

export const tableMock: TableMock<ILead> = {
  columns: columnsDefLeads,
  datasource: mock.items
};

export const mockFooterElements = {
  start: `<button id="footer-start">בטיפול</button>`,
  end: `<svg id="footer-end" width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="dot-menu">
          <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M15.0829 16.8096C15.9877 16.8096 16.8924 15.9048 16.8924 15C16.8924 14.0953 15.9877 13.1905 15.0829 13.1905C14.1782 13.1905 13.2752 14.0953 13.2752 15C13.2752 15.9048 14.1782 16.8096 15.0829 16.8096ZM7.84482 16.8096C8.74959 16.8096 9.65435 15.9048 9.65435 15C9.65435 14.0953 8.74959 13.1905 7.84482 13.1905C6.94006 13.1905 6.03711 14.0953 6.03711 15C6.03711 15.9048 6.94006 16.8096 7.84482 16.8096ZM22.321 16.8096C23.2258 16.8096 24.1305 15.9048 24.1305 15C24.1305 14.0953 23.2258 13.1905 22.321 13.1905C21.4163 13.1905 20.5133 14.0953 20.5133 15C20.5133 15.9048 21.4163 16.8096 22.321 16.8096Z" fill="#E10514"/>
          </g>
        </svg>`
};
